<template>
<div id="allocation-modal-container" :style="{width:width,height:height,top:top,left:left}" v-show="isShow">
  <!--top menu container-->
  <div class="top-menu-container">
    <span class="title">{{title}}</span>
    <div class="iconfont icon-close" @click="closeEvent"></div>
  </div>
  <!--allocation content container-->
  <div class="modal-content-container" v-if="type==='allocation'">
    <div class="top-allocation-select-container">
      <span class="lable">选择所属人</span>
      <div class="search-input-container">
        <serach-input></serach-input>
      </div>
      <span class="search-button" @click='searchSubUserList'>搜索</span>
      <!-- <span class="search-button" @click='searchSubUserList'>搜索</span> -->
    </div>
    <div class="bottom-tip-container">
      <span class="modal-tip">注：直接选择或搜索选择</span>
    </div>
  </div>
  <!--areaEditor content container-->
  <div class="modal-content-container" v-if="type==='areaEditor'">
    <div class="top-price-modify-container">
      <span class="lable">修改面积</span>
      <div class="search-input-container">
        <serach-input></serach-input>
      </div>
      <span class="search-button">m²</span>
    </div>
    <div class="price-modify-container">
      <span class="lable">修改价格</span>
      <div class="select-item" :class="item.class" v-for="(item,index) in area" :key="'select-'+index">
        <i :class="item.active ? 'dot-active' : 'dot'" @click="changeCalcWay(index)"></i>
        <span :class="item.class">{{item.key}}</span>
      </div>
    </div>
    <div class="calc-result-input">
      <div class="search-input-container">
        <serach-input></serach-input>
      </div>
    </div>
  </div>
  <div class="modal-content-container" v-if="type === 'custom'">
    <slot></slot>
  </div>
  <div class="button-container">
    <span class="cancel-button" @click="cancelEvent">取消</span>
    <span class="sure-button" @click="sureEvent">确定</span>
  </div>
</div>
</template>

<script>
import SerachInput from '@/components/new/common/input/SerachInput'
export default {
  name: 'allocationModal',
  components: {
    SerachInput,
    //BannerComponent
  },
  props: {
    maskElement: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '400px'
    },
    height: {
      type: String,
      default: '210px'
    },
    theme: {
      type: String,
      default: '#333333'
    },
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'custom'
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    success: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {

      }
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      top: 0,
      left: 0,
      area: [{
          key: '按面积计算',
          value: 'area',
          active: true,
          class: 'area-calc'
        },
        {
          key: '按价格计算',
          value: 'price',
          active: false,
          class: 'price-calc'
        }
      ]
    }
  },
  mounted() {
    this.initView();
  },
  methods: {
    //init View
    initView() {
      document.addEventListener('click', (e) => {
        this.top = `calc(50% - ${parseInt(this.$props.height.split('px')[0])/2}px)`;
        this.left = `calc(50% - ${parseInt(this.$props.width.split('px')[0])/2}px)`;
        let targetElement = e.target.className;
        if (targetElement === 'model-shadow-container') {
          e.target.parentElement.removeChild(e.target);
          this.closeEvent();
        }
      });
    },
    // close modal 
    closeEvent() {
      this.close();
      this.isShow = false;
    },
    // cancel option
    cancelEvent() {
      this.isShow = false
      this.cancel();
    },
    // sure option
    sureEvent() {
      this.isShow = false
      this.success();
    },
    // 点击切换计算方式
    changeCalcWay(index) {
      this.area.forEach((value, key) => {
        if (index === key) {
          value.active = true;
        } else {
          value.active = false;
        }
      })
    },
    // searchSubUserList(){
    //   this.$store.dispatch('searchEditorUserList',123)
    // }
  }
}
</script>

<style scoped>
#allocation-modal-container {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  top: calc(50% - 93.5px);
  left: calc(50% - 150px);
  background-color: #ffffff;

}

.top-menu-container {
  width: 100%;
  height: 40px;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-menu-container .title {
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #fefeff;
  margin: 0 0 0 20px;
}

.top-menu-container .icon-close {
  font-size: 14px;
  color: #fefeff;
  margin: 0 12px 0 0;
  cursor: pointer;
}

/** modal content conmodal */

.modal-content-container {
  width: 100%;
  display: flex;
  height: fit-content;
  max-height: calc(100% - 109px);
  flex-direction: column;
}

.top-allocation-select-container,
.top-price-modify-container,
.calc-result-input {
  margin: 20px 0 14px 20px;
  width: calc(100% -20px);
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.calc-result-input {
  margin: 10px 0 0 89px;
  width: fit-content;
}

.lable {
  margin: 0 10px 0 0;
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;

}

.search-button {
  margin: 0 0 0 10px;
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #2783f2;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.price-modify-container {
  width: calc(100% - 20px);
  margin: 0px 0 0 20px;
  display: flex;
  align-items: center;
}

.select-item {
  display: flex;
  align-items: center;
}

.dot,
.dot-active {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 5px 0 0;
  cursor: pointer;
}

.dot {
  border: solid 1px #e5e5e5;
}

.dot-active {
  background-color: #2783f2;
}

.area-calc {
  margin: 0 19px 0 0;
}

.bottom-tip-container {
  width: calc(100% - 20px);
  margin: 0px 0 0 20px;
}

.bottom-tip-container .modal-tip {
  font-family: FZLTHJW--GB1-0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #b3b3b3;
}

/** custom content container */
.custom-content-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, .3);
}

/** button container */
.button-container {
  width: fit-content;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 39px 0 30px 106px;
}

.button-container span {
  width: 84px;
  height: 24px;
  border-radius: 12px;
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

.button-container .cancel-button {
  border: solid 1px #cccccc;
  color: #999999;
  margin: 0 10px 0 0;
}

.button-container .sure-button {
  background-color: #2783f2;
  color: #fff;
  margin: 0 0 0 10px;
}
</style>
